<template>
	<div>
		<div class="top-space-smag"></div>
		<div class="smag-image-background"><img src="~@static/tid5/images/SALLING_TOPBANNER2.jpg" /></div>
		<div class="smag-logo-disable-page"><img src="~@static/tid5/images/smag-logo.png"/></div>
		<div class="smag">
			<div class="bil-brocken sm-brocken fo-brocken">
				Websitet er midlertidigt ikke tilgængeligt
			</div>
			<div class="bil-brocken-sub sm-brocken-sub fo-brocken-sub">
				<template v-if="platform === ''">
					{{tenantSettings.tenantUnavailableCustomText ? tenantSettings.tenantUnavailableCustomText : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'android'">
					{{tenantSettings.tenantUnavailableCustomTextAndroid ? tenantSettings.tenantUnavailableCustomTextAndroid : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
				<template v-else-if="platform === 'ios'">
					{{tenantSettings.tenantUnavailableCustomTextIos ? tenantSettings.tenantUnavailableCustomTextIos : "Vi er i gang med at opdatere systemet, men er snart færdige. Vi beklager ulejligheden."}}
				</template>
			</div>
			<div class="center-button-align"><v-btn @click="siteNotAvailableRedirect" flat class="salling-btn">Gå til Salling.dk</v-btn></div>
		</div>
		<div class="smag-bottom">tilgængeligt</div>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";
	export default {
		name: "SiteNotAvailableTid5",
		props: ["siteNotAvailableRedirect", "platform"],
		computed: {
			...mapGetters(["tenantSettings"])
		}
	};
</script>

<style scoped>

</style>
